<template>
    <div class="container-fluid" style="margin-top: 50px;">
        
        <div class="row justify-content-center">
            <div class="col-xl-10 col-lg-12 col-md-9">
                
                <Loading v-if="loading === true"/>

                <div class="row">
                    <div class="col-lg-3 col-md-2"></div>
                    <div class="col-lg-6 col-md-8 text-center">
                        <a href="/">
                            <img src="../assets/sign-up-logo.jpeg"/>
                        </a>
                    </div>
                    <div class="col-lg-3 col-md-2"></div>
                </div>

                <div v-if="step === 'subscriptionOptions'">
                    <div class="row">
                        <div class="col-12 text-center">
                            <h4>Pick your plan</h4>
                            <p class="mb-0 mt-0">All plans come with a 15-day trial period</p>
                            <div class="o-switch btn-group" data-toggle="buttons" role="group">
                                <label class="btn btn-three-way-toggle active" @click="paymentSchedule = 1">
                                    <input type="radio" name="schedule" value="1" v-model="paymentSchedule" checked> Monthly
                                </label>
                                <label class="btn btn-three-way-toggle" @click="paymentSchedule = 3">
                                    <input type="radio" name="schedule" value="3" v-model="paymentSchedule"> Quarterly
                                </label>
                                <label class="btn btn-three-way-toggle" @click="paymentSchedule = 12">
                                    <input type="radio" name="schedule" value="12" v-model="paymentSchedule"> Annually
                                </label>
                            </div>
                        </div>
                    </div>
                    
                    <div class="row my-md-0 my-3">
                        <div class="col-md-9"></div>
                        <div class="col-md-3 text-center my-md-0">
                            <a href="#details-grid" v-scroll-to="'#details-grid'">View Comparison</a>
                        </div>
                    </div>

                    <div class="row mt-3">
                        <div class="col-lg-3" v-for="plan in plansAvailable[paymentSchedule]" :key="plan.id">
                            <div class="card">
                                <div class="card-header text-center">
                                    <h5>{{ plan.plan_data.nickname }}</h5>
                                </div>
                                <div class="card-body text-center">
                                    <SubscriptionDetails :planNickname="plan.type" />
                                    <hr>
                                    <h6 class="mt-4">${{ (plan.plan_data.amount/100).toFixed(2) }}</h6>
                                    <p v-if="paymentSchedule != 1" class="mt-0"><i>(${{ (plan.plan_data.amount/100/paymentSchedule).toFixed(2) }} per month)</i></p>
                                    <button @click="proceedToBasicInfo(plan)" class="btn btn-primary mt-5">SELECT</button>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-3">
                            <div class="card">
                                <div class="card-header text-center">
                                    <h5>Platinum Curator</h5>
                                </div>
                                <div class="card-body text-center">
                                    <SubscriptionDetails :planNickname="'platinum'" />
                                    <hr>
                                    <h6 class="mt-4 mb-5">Contact us for more info</h6>
                                    <button :style="paymentSchedule == 1 ? 'margin-top: 8px;' : 'margin-top: 45px;'" @click="step = 'platinumRequest'" class="btn btn-primary">Contact Us</button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row mt-5 mb-5" id="details-grid">
                        <div class="col-12">
                            <h6>Further Details Grid</h6>
                            <SubscriptionDetailsGrid />
                        </div>
                    </div>
                </div>

                <div v-if="step === 'basicInfo'">
                    <div v-if="newMuseum == false">
                        <div class="row">
                            <div class="col text-center">
                                <h3 class="mt-1">Sign Up</h3>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <select class="form-control custom-dropdown" v-model="selectedMuseum">
                                    <option disabled selected value="">Pick your Institute</option>
                                    <option v-for="museum in allMuseums" :key="museum.id" :value="museum.id">{{ museum.name }}</option>
                                </select>
                            </div>
                        </div>

                        <div class="row mt-3">
                            <div class="col ml-2">
                                <button class="btn btn-secondary" @click="newMuseum = true"><b>I do not see my Institute</b></button>
                            </div>
                        </div>
                        <Alert v-if="errorMessage.length > 0" :message="errorMessage" :error="true"/>
                        <Alert v-if="successMessage.length > 0" :message="successMessage" :error="false"/>
                        <div class="row mt-5">
                            <div class="col-12">
                                <h5>Your Personal Info</h5>
                            </div>
                            <div class="col-lg-4">
                                <label>Full Name</label>
                                <input :disabled="firebaseUID != null" v-model="newUser.name" class="form-control"/>
                            </div>
                            <div class="col-lg-4">
                                <label>Display Name</label>
                                <input :disabled="firebaseUID != null" v-model="newUser.displayName" class="form-control"/>
                            </div>
                            <div class="col-lg-4">
                                <label>Job Title</label>
                                <input :disabled="firebaseUID != null" v-model="newUser.jobTitle" class="form-control"/>
                            </div>
                        </div>

                        <div class="row mt-3">
                            <div class="col-lg-6">
                                <label>Email Address</label>
                                <input :disabled="firebaseUID != null" v-model="newUser.email" class="form-control"/>
                            </div>
                            <div class="col-lg-6">
                                <label>Phone Number</label>
                                <input :disabled="firebaseUID != null" v-model="newUser.phone" class="form-control"/>
                            </div>
                        </div>

                        <div class="row mt-3">
                            <div class="col-lg-6">
                                <div class="form-group">
                                    <label>Enter Password</label>
                                    <input 
                                        :disabled="firebaseUID != null" 
                                        v-model="newUser.password" 
                                        :type="!viewPassword ? 'password' : 'text'" 
                                        class="form-control" 
                                        :style="passwordError === true ? 'background-color: #FFD666;' : ''" 
                                        placeholder="Password">
                                </div>
                            </div>
                            <div class="col-lg-6">
                                 <div class="form-group">
                                    <label>Verify Password</label>
                                    <input 
                                        :disabled="firebaseUID != null" 
                                        v-model="newUser.verifyPassword" 
                                        :type="!viewPassword ? 'password' : 'text'" 
                                        class="form-control" 
                                        :style="passwordError === true ? 'background-color: #FFD666;' : ''" 
                                        placeholder="Verify Password">
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col">
                                <a class="ml-2" style="font-size: 12px; cursor: pointer;" @click="viewPassword = !viewPassword"><b>Show Password</b></a>
                            </div>
                        </div>

                        <div class="row my-5">
                            <div class="col">
                                <button @click="proceedToPayment()" class="btn btn-primary">Continue</button>
                                <button @click="step = 'subscriptionOptions'" class="btn btn-primary ml-3">Back</button>
                            </div>
                        </div>
                    </div>

                    <!-- New Institute Form -->
                    <div v-if="newMuseum == true" class="mt-4">
                        <p class="text-center"><i>Please fill in the following form and we will get back to you as soon as possible</i></p>
                        <div class="row">
                            <div class="col-12 mt-3">
                                <h5>Your Personal Info</h5>
                            </div>
                            <div class="col-4">
                                <label>Full Name</label>
                                <input v-model="newUserRequest.name" class="form-control"/>
                            </div>
                            <div class="col-4">
                                <label>Phone Number</label>
                                <input v-model="newUserRequest.phone" class="form-control"/>
                            </div>
                            <div class="col-4">
                                <label>Email Address</label>
                                <input v-model="newUserRequest.email" class="form-control"/>
                            </div>
                        </div>

                        <div class="row mt-5">
                            <div class="col-12">
                                <h5>Your Institute's Info</h5>
                            </div>
                            <div class="col-6">
                                <label>Name</label>
                                <input v-model="newMuseumInfo.name" class="form-control"/>
                            </div>
                            <div class="col-6">
                                <label>Address</label>
                                <input v-model="newMuseumInfo.address" class="form-control"/>
                            </div>
                        </div>

                        <div class="row mt-5">
                            <div class="col-3">
                                <label>City</label>
                                <input v-model="newMuseumInfo.city" class="form-control"/>
                            </div>
                            <div class="col-3">
                                <label>State/Province</label>
                                <input v-model="newMuseumInfo.state" class="form-control"/>
                            </div>
                            <div class="col-3">
                                <label>Postal Code</label>
                                <input v-model="newMuseumInfo.postalCode" class="form-control"/>
                            </div>
                            <div class="col-3">
                                <label>Country</label>
                                <input v-model="newMuseumInfo.country" class="form-control"/>
                            </div>
                        </div>

                        <div class="row mt-5">
                            <div class="col">
                                <button @click="applyForNewMuseum()" class="btn btn-primary">Submit Form</button>
                                <button @click="newMuseum = false; errorMessage = ''; successMessage = '';" class="btn btn-primary ml-3">Back</button>
                            </div>
                        </div>
                    </div>
                </div>

                <div v-else-if="step == 'platinumRequest'">
                    <p class="text-center"><i>Please fill in the following form and we will get back to you as soon as possible</i></p>
                    <Alert v-if="errorMessage.length > 0" :message="errorMessage" :error="true"/>
                    <Alert v-if="successMessage.length > 0" :message="successMessage" :error="false"/>
                    <div class="row">
                        <div class="col-12 mt-3">
                            <h5>Your Personal Info</h5>
                        </div>
                        <div class="col-4">
                            <label>Full Name</label>
                            <input v-model="platinumUserRequest.name" class="form-control"/>
                        </div>
                        <div class="col-4">
                            <label>Phone Number</label>
                            <input v-model="platinumUserRequest.phone" class="form-control"/>
                        </div>
                        <div class="col-4">
                            <label>Email Address</label>
                            <input v-model="platinumUserRequest.email" class="form-control"/>
                        </div>
                    </div>
                     <div class="row mt-5">
                        <div class="col">
                            <button @click="submitPlatinumRequest()" class="btn btn-primary">Submit Form</button>
                            <button @click="step = 'subscriptionOptions'; errorMessage = ''; successMessage = '';" class="btn btn-primary ml-3">Back</button>
                        </div>
                    </div>

                </div>

                <div :style="step == 'paymentInfo' ? 'display: block;' : 'display: none;'">
                    <div class="row mt-5 text-center">
                        <div class="col">
                            <div class="card" id="card-payment-info">
                                <div class="card-header">
                                    <h5>Payment Information</h5>
                                </div>
                                <div class="card-body">
                                    <div class="row mt-3">
                                        <div class="col-12">
                                             <div ref="card">
                                                <!-- Stripe -->
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mt-5 text-left">
                                        <div class="col">
                                            <p><b>Billing Information:</b></p>
                                        </div>
                                    </div>
                                    <div class="row text-left">
                                        <div class="col">
                                            <label>Name on Card</label>
                                            <input autocomplete="name" v-model = "billingInfo.name" class="form-control"/>
                                        </div>
                                    </div>
                                    <div class="row mt-4 text-left">
                                        <div class="col-lg-4">
                                            <label>Address</label>
                                            <input autocomplete="address-line1" v-model = "billingInfo.address1" class="form-control"/>
                                        </div>
                                        <div class="col-lg-4">
                                            <label>Address2</label>
                                            <input autocomplete="address-line2" v-model = "billingInfo.address2" class="form-control"/>
                                        </div>

                                         <div class="col-lg-4">
                                            <label>City</label>
                                            <input autocomplete="address-level2" v-model = "billingInfo.city" class="form-control"/>
                                        </div>
                                    </div>
                                    <div class="row mt-3 text-left">
                                        <div class="col-lg-4">
                                            <label>State/Province</label>
                                            <input autocomplete="address-level1" v-model = "billingInfo.state" class="form-control"/>
                                        </div>
                                        <div class="col-lg-4">
                                            <label>Postal Code</label>
                                            <input autocomplete="postal-code" v-model = "billingInfo.postalCode" class="form-control"/>
                                        </div>
                                        <div class="col-lg-4">
                                            <label>Country</label>
                                            <select autocomplete="country-name" class="form-control custom-dropdown" v-model="billingInfo.country">
                                                <option disabled selected value="">Pick a Country</option>
                                                <option v-for="country in countries" :key="country.code" :value="country.code">{{ country.name }}</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="row mt-3">
                                        <div class="col">
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col">
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col">
                                            <button @click="createSubscription()" class="btn btn-primary mt-5">Submit</button>
                                        </div>
                                    </div>
                                     <div class="row">
                                        <div class="col">
                                            <button @click="step = 'basicInfo'" class="btn btn-primary mt-2">Back</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Museums from '../controllers/museum.controller';
    import Users from '../controllers/user.controller';
    import Admins from '../controllers/admin.controller';
    import Countries from '../controllers/countries.controller';
    import Payments from '../controllers/payments.controller';
    import Subscriptions from '../controllers/subscriptions.controller';
    import SubscriptionDetails from '../components/SubscriptionDetails';
    import SubscriptionDetailsGrid from '../components/SubscriptionDetailsGrid';

    export default {
        name: 'Signup',
        components: {
            SubscriptionDetails,
            SubscriptionDetailsGrid
        },
        data: function() {
            return {
                spk: process.env.VUE_APP_STRIPE_PK,
                stripe: undefined,
                step: 'subscriptionOptions',
                token: this.$route.params.token,
                allMuseums: [],
                selectedMuseum: '',
                plansAvailable: [],
                paymentSchedule: 1, 
                isPlatinum: false,
                newUser: {
                    name: '',
                    displayName: '',
                    jobTitle: '',
                    email: '',
                    phone: '',
                    password: ''
                },
                newMuseum: false,
                newMuseumInfo: {
                    name: '',
                    address: '',
                    city: '',
                    state: '',
                    postalCode: '',
                    country: ''
                },
                newUserRequest: {
                    name: '',
                    phone: '',
                    email: ''
                },
                platinumUserRequest: {
                    name: '',
                    phone: '',
                    email: ''
                },
                billingInfo: {
                    name: '',
                    address: '',
                    city: '',
                    state: '',
                    postalCode: '',
                    country: ''
                },
                selectedPlan: null,
                payment: {},
                errorMessage: '',
                successMessage: '',
                viewPassword: false,
                countries: [],
                firebaseUID: null,
                passwordError: false,
                loading: false
            }
        },
        beforeMount: async function() {
            this.loading = true;
            try {
                this.allMuseums = await Museums.getAll();

                if (this.token !== undefined) {
                    let user = await Users.getBySignUpToken(this.token);

                    if (!user) {
                        this.errorMessage = "User not found. Please ensure you are using the correct link";
                        this.loading = false;
                        return;
                    }

                    this.newUser = {
                        id: user.id,
                        name: user.name,
                        displayName: user.display_name,
                        jobTitle: user.job_title,
                        email: user.email,
                        phone: user.phone_number,
                        platinum_plan: user.platinum_plan
                    };

                    if (user.platinum_plan) {
                        this.isPlatinum = true;
                        this.step = 'basicInfo';
                    }

                    if (user && this.allMuseums && this.allMuseums.length > 0) {
                        const museumId = user.museum_ids.replace('[', '').replace(']', '');
                        const foundMuseum = this.allMuseums.find(museum => museum.id == museumId);
                        if (foundMuseum) {
                            this.selectedMuseum = foundMuseum.id;
                        }
                    }
                }

                this.plansAvailable = await Payments.getActivePlans();
                
                // Ensure all the plans are ordered based on their price
                this.orderPlans();

                let allCountries = await Countries.getAll();
                
                for (let country of allCountries) {
                    this.countries.push({
                        name: country.name,
                        code: country.country_code
                    });
                }
            } catch (error) {
                console.error("Error in beforeMount:", error);
                this.errorMessage = "Something went wrong loading the page. Please try again.";
            } finally {
                this.loading = false;
            }
        },

        methods: {
            async applyForNewMuseum() {
                this.loading = true;
                this.errorMessage = "";
                this.successMessage = "";

                if (!this.newUserRequest.name || !this.newUserRequest.phone || !this.newUserRequest.email) {
                    this.errorMessage = "Please fill in all your personal information";
                    this.loading = false;
                    return;
                }

                if (!this.newMuseumInfo.name || !this.newMuseumInfo.address || !this.newMuseumInfo.city || !this.newMuseumInfo.state || !this.newMuseumInfo.postalCode || !this.newMuseumInfo.country) {
                    this.errorMessage = "Please fill in all of your institute's information";
                    this.loading = false;
                    return;
                }

                try {
                    let sent = await Museums.requestToBeListed(this.newUserRequest, this.newMuseumInfo);

                    if (sent === true) {
                        this.successMessage = "We have received your inquiry. Someone from our team will contact you shortly";
                    } else if (sent.error) {
                        this.errorMessage = sent.error;
                    } else {
                        this.errorMessage = "Something went wrong sending your info. Please try again later";
                    }
                } catch (error) {
                    this.errorMessage = error.message || "Something went wrong sending your info. Please try again later";
                } finally {
                    this.loading = false;
                }
            },

            async proceedToBasicInfo(plan) {
                this.errorMessage = "";
                this.successMessage = "";
                this.selectedPlan = plan;
                this.errorMessage = "";
                this.step = 'basicInfo';
            },

            async proceedToPayment(plan) {
                this.passwordError = false;
                if (!this.selectedMuseum) {
                    this.errorMessage = "Please select a museum";
                    return;
                }

                if (!this.newUser.password) {
                    this.errorMessage = "The password field is mandatory";
                    return;
                }

                if (this.newUser.password != this.newUser.verifyPassword) {
                    this.errorMessage = "Passwords not matching";
                    return;
                }

                this.loading = true;

                let museums = [];
                museums.push(this.selectedMuseum);

                // Create the new user
                if (this.firebaseUID == null) {
                    let firebase = await Admins.createCurator(this.newUser.name, this.newUser.email, this.newUser.displayName, this.newUser.jobTitle, this.newUser.phone, this.newUser.password, museums);
                    if (firebase.error) {
                        if (firebase.passwordError) {
                            this.passwordError = true;
                            

                        }
                        this.errorMessage = firebase.error;
                        this.loading = false;
                        return;
                    } else if (firebase === false) {
                        this.errorMessage = "Something went wrong while creating your account";
                        this.loading = false;
                        return;
                    } else {
                        this.firebaseUID = firebase;
                        // Check if the user is platinum, for which case we will need to create a subscription
                        if (this.newUser.platinum_plan) {
                            let planCreated = await Admins.createSubscription(this.firebaseUID, this.newUser.platinum_plan.id);
                            if (planCreated.error) {
                                this.errorMessage = firebase.error;
                                this.loading = false;
                                return;
                            } else if (planCreated === false) {
                                this.errorMessage = "Something went wrong while creating your subscription";
                                this.loading = false;
                                return;
                            }
                        }
                    }
                }

                // Reset any errors and move to the next step
                this.errorMessage = "";

                // If the user is a platinum user, skip the payment method
                if (this.isPlatinum === true) {
                    await this.authenticateUser();
                } else {
                    this.step = 'paymentInfo';

                    // Create the Stripe card and mount it
                    this.stripe = Stripe(this.spk);
                    this.card = this.stripe.elements().create('card', {
                        style: {
                            base: {
                                fontWeight: 500,
                                fontFamily: 'Roboto, Open Sans, Segoe UI, sans-serif',
                                fontSize: '16px',
                                fontSmoothing: 'antialiased',
                            }
                        }
                    });
                
                    this.card.mount(this.$refs.card);
                }
                this.loading = false;
            },

            async createSubscription() {
                this.errorMessage = "";
                this.successMessage = "";

                if (!this.billingInfo.address1 || !this.billingInfo.address1 || !this.billingInfo.city || !this.billingInfo.state || !this.billingInfo.postalCode || !this.billingInfo.country) {
                    this.errorMessage = "Please make sure all mandatory fields are filled";
                    return;
                }

                this.loading = true;

                try {
                    let result = await this.stripe.createPaymentMethod({
                        type: 'card',
                        card: this.card,
                        billing_details: {
                            name: this.billingInfo.name,
                            address: {
                                line1: this.billingInfo.address1,
                                line2: this.billingInfo.address2,
                                city: this.billingInfo.city,
                                state: this.billingInfo.state,
                                postal_code: this.billingInfo.postalCode,
                                country: this.billingInfo.country
                            }
                        }
                    });

                    if (result.error) {
                        this.errorMessage = result.error.message;
                        return;
                    }

                    let created = await Subscriptions.create(result.paymentMethod.id, this.newUser.email, this.selectedPlan.plan_id, this.selectedPlan.id, this.firebaseUID);

                    if (created == false) {
                        this.errorMessage = "Something went wrong while creating your subscription";
                    } else if (created.error) {
                        this.errorMessage = created.error;
                    } else {
                        // The user has been created and the payment went through, 
                        // let's redirect them to the dashboard after we log them in
                        await this.authenticateUser();
                    }
                } catch (error) {
                    this.errorMessage = error.message || "Something went wrong creating your subscription";
                } finally {
                    this.loading = false;
                }
            },

            async authenticateUser() {
                try {
                    let loggedIn = await Users.authenticate(this.newUser.email, this.newUser.password);

                    if (loggedIn === true) {
                        this.$router.push('/dashboard');
                    } else {
                        this.errorMessage = "Something went wrong while logging you in, please try again.";
                    }
                } catch (error) {
                    this.errorMessage = error.message || "Something went wrong while logging you in, please try again.";
                }
            },

            async submitPlatinumRequest() {
                this.loading = true;
                this.successMessage = "";
                this.errorMessage = "";

                if (!this.platinumUserRequest.name || !this.platinumUserRequest.phone || !this.platinumUserRequest.email) {
                    this.errorMessage = "Please fill out all mandatory fields";
                    this.loading = false;
                    return;
                }

                try {
                    let sent = await Users.requestPlatinumAccount(this.platinumUserRequest.name, this.platinumUserRequest.phone, this.platinumUserRequest.email);

                    if (sent === true) {
                        this.successMessage = "Thank you for reaching out, The Museo Team will be in touch soon!";
                        this.platinumUserRequest = { name: '', phone: '', email: '' };
                        setTimeout(() => { this.successMessage = ''; }, 15000);
                    } else if (sent.error) {
                        this.errorMessage = sent.error;
                    } else {
                        this.errorMessage = "Something went wrong while sending your email. Please try again later";
                    }
                } catch (error) {
                    this.errorMessage = error.message || "Something went wrong while sending your email. Please try again later";
                } finally {
                    this.loading = false;
                }
            },

            orderPlans() {
                this.plansAvailable[1].sort((a, b) => {
                    return a.plan_data.amount/100 - b.plan_data.amount/100;
                });

                this.plansAvailable[3].sort((a, b) => {
                    return a.plan_data.amount/100 - b.plan_data.amount/100;
                });

                this.plansAvailable[12].sort((a, b) => {
                    return a.plan_data.amount/100 - b.plan_data.amount/100;
                });
            }
        }
    }
</script>